import { render, staticRenderFns } from "./PiePaginaComponent.vue?vue&type=template&id=92ec2540&scoped=true"
import script from "./PiePaginaComponent.vue?vue&type=script&lang=js"
export * from "./PiePaginaComponent.vue?vue&type=script&lang=js"
import style0 from "./PiePaginaComponent.vue?vue&type=style&index=0&id=92ec2540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ec2540",
  null
  
)

export default component.exports